<template>
  <div id="app">
    <div class="main">
      <el-card class="box-card leftcon left">
        <div class="left-con">
          <div class="pd" v-if="subject.judge_status">
            <div class="title">判 断</div>
            <div v-for="(item,key) in subject.judge" :key="'panduan1'+key" class="con" :id="'panduan1-'+key">
              <!-- <b>{{'第 ' + (key+1) + ' 题'}}<span style="margin-left: 1.25rem;">({{item.score+'分'}})</span></b> -->
              <div class="option">
                <p class="optionitem"> {{'第 ' + (key+1)+ ' 题 '}} ({{item.score+'分'}}){{item.name}}</p>
                <el-radio-group v-model="temp[key]">
                  <el-radio label="1"   @change="change('judge','local', key,'1')">正确</el-radio>
                  <el-radio label="0"   @change="change('judge','local', key,'0')">错误</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="xz" v-if="subject.select_status">
            <div class="title">选 择</div>
            <div v-for="(item,key) in subject.selest" :key="'xuanze1'+key" class="con" :id="'xuanze1-'+key">
              <!-- <b >{{'第 ' + (key+1)+ ' 题 '}} <span style="margin-left: 1.25rem;">({{item.score+'分'}})</span></b> -->
              <div class="option">
                <p class="optionitem">{{'第 ' + (key+1)+ ' 题 '}} ({{item.score+'分'}}) 【{{item.select_type}}】 {{item.name}}</p>
                  <el-checkbox   v-for="(i,key1) in item['choice']"  :key="key1" :label="i" style="width: 100%;" @change="change('select','local', key,key1)">
                         {{options[key1]}}.{{i}}
                 </el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <div class=" rightcon right">
        <el-card class="box-card">
          <div class="rightconhead">
            <div>答题卡</div>
            <time>{{timeText}}</time>
          </div>
          <div class="right-con">
            <div class="detail">
              <div class="detailleft">试卷名称</div>
              <div class="">：   {{subject.name}}</div>
              <div class="detailleft">总题数</div>
              <div class="">： {{subject.judge.length+subject.selest.length}}题</div>
              <div class="detailleft">及格分</div>
              <div class="">： {{subject.score}}分</div>
            </div>
            <div style=" max-height: calc( 100vh - 340px); overflow: auto;">
               <div class="title" style="margin-top: 0;">判 断</div>
              <div class="num" v-if="subject.judge_status">
                 <el-button type="primary" plain v-for="(item,key) in subject.judge" :key="'panduan11'+key"  :id="'judge_local_'+key"  @click="buttonitem('#panduan1-'+key)">{{key+1}}</el-button>
              </div>
              <div class="title">选 择</div>
              <div class="num"  v-if="subject.select_status" >
                <el-button type="primary" plain   v-for="(item,key) in subject.selest" :key="'xaunze11'+key"  :id="'select_local_'+key" @click="buttonitem('#xuanze1-'+key)">{{key+1}}</el-button>
              </div>
            </div>
          </div>
          <el-button class="sub" type="primary" @click='goback()'>交卷</el-button>
        </el-card>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'App',
     props: {
        time: {
            type: Number,
            default: 0
        }
    },
    data() {
      return {
        second: 60,//考试时间倒计时秒
        timing_i: 1,
        minute: 0,//考试时间倒计时分
        timeInterval: null,
        info:this.$store.state.info,
        showTime: this.time,
        timeText:'',
        options: ['A', 'B', 'C', 'D','E','F','G','H','I'],
        plan:{
          num:this.$route.query.num,
          type:'subject',
        },
        subject:{
          e_time:'',
          list:[],
          num:this.$route.query.num,
          judge_status:false,
          select_status:false,
          score:'',//的分数
          count:'',//总题数
          t:'',//答对题数
          name:'',
          judge:[],//判断
          selest:[],//选择
        },
        temp:{
          local:[],
          public:[]
        },
      }
    },
    components: {},
    mounted () {
       this.get_task_info();
       if (this.showTime >= 0){
           this.timing()
          }else{
             this.countDown()
       }
       },
    methods: {
      timing () {
        let _this=this
          _this.isColor = true
          clearInterval(_this.timeInterval)
          _this.timeInterval = setInterval(() => {
            _this.second--
            if(_this.second<0){
              _this.timing_i++
              _this.second=59
            }
            _this.minute=_this.subject.e_time-_this.timing_i
            if(_this.minute==1 && _this.second==0){
               this.$message({
                        message: '考试时间还有三分钟，请抓紧时间',
                        type: 'warning'
                      });
            }
            if( _this.minute==0 && _this.second==0){
              _this.goback()
              clearInterval(_this.timeInterval)
            }
              _this.timeText = _this.minute + '分' + _this.second+ '秒'
          }, 1000)
      },
      change(type1,type2,key,key1){
        let _this=this
        if(type1=='select'){
            if(_this.subject.selest[key].user_choice.length>0){
              if( _this.subject.selest[key]['user_choice'].indexOf(_this.options[key1])=='-1'){
                _this.subject.selest[key]['user_choice'].push(_this.options[key1])
              }else{
               _this.subject.selest[key]['user_choice'].splice(_this.subject.selest[key]['user_choice'].indexOf(_this.options[key1]),1)
              }
            }else{
            _this.subject.selest[key].user_choice.push(_this.options[key1])
          }
          if( _this.subject.selest[key]['user_choice'].length==0){
            document.getElementById(type1+'_'+type2+'_'+key).style.backgroundColor="#ecf5ff"
          }else{
            document.getElementById(type1+'_'+type2+'_'+key).style.backgroundColor="#00FF00"
          }
        }else{
          _this.subject.judge[key]['user_choice']=[]
          _this.subject.judge[key]['user_choice'].push(key1)
          if( _this.subject.judge[key]['user_choice'].length==0){
            document.getElementById(type1+'_'+type2+'_'+key).style.backgroundColor="#ecf5ff"
          }else{
            document.getElementById(type1+'_'+type2+'_'+key).style.backgroundColor="#00FF00"
          }
        }
      },
      goback(){
        let _this=this
        let data={
          num:_this.subject.num,
          list:_this.subject.selest.concat(_this.subject.judge)
        }
         _this.axios.post('/v2/user_evaluate/exam_save', {
            data:data //注意post请求发送参数的方式和get请求方式是有区别的
          }).then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                clearInterval(_this.timeInterval)
                window.close()
              }else{
                _this.$message.error(res.data.msg);
              }
            }else{
              _this.$message.error('服务器内部错误');
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误');
          });
      },
      count_down(){
        if(!this.dstimers){
          this.dstimers= setInterval(() => {
          let yy = new Date().getFullYear();
          　　let mm = new Date().getMonth()+1;
          　　let dd = new Date().getDate();
          　　let hh = new Date().getHours();
          　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
          　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
          　　this.autograph.time = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
            return;
          }, 1000);
        }
      },
      get_task_info(){
        let _this=this;
        _this.axios.get('/v2/user_evaluate/get_subject',{
          params: {num: _this.subject.num },}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.subject.list=res.data.data.subject
              _this.subject.e_time=res.data.data.time
               _this.subject.name=res.data.data.name
               _this.subject.score=res.data.data.score
               _this.timing()
               // console.log(_this.subject.list.eva.length)
               if(Object.keys(_this.subject.list.eva).length>0){
                 _this.set_info_list('eva')
               }
                if(Object.keys(_this.subject.list.file).length>0){
                 _this.set_info_list('file')
               }

                if(Object.keys(_this.subject.list.video).length>0){
                 _this.set_info_list('video')
               }
               console.log(_this.subject)
              if(_this.subject.judge.length>0){
                 _this.subject.judge_status=true;

                 _this.setxzitem('judge');
              }
              if(_this.subject.selest.length>0){
                _this.subject.select_status=true;
                _this.setxzitem('select');
              }
              console.log(_this.subject.list.eva)
            }else{
              _this.$message.error(res.data.msg);
              clearInterval(_this.timeInterval)
              window.close()
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        })
      },
      set_info_list(type){
        let _this=this
        Object.keys(_this.subject.list[type]).forEach((key) => {
          _this.subject.list[type][key]['user_choice']=[]
          if(_this.subject.list[type][key].choice!=0){
            _this.subject.list[type][key]['t_type']=type
            _this.subject.selest.push(_this.subject.list[type][key])
          }else{
            _this.subject.list[type][key]['t_type']=type
            _this.subject.judge.push(_this.subject.list[type][key])
          }
        })
      },
      //设置字符串
      setxzitem(type){
        let _this=this
        if(type=='select'){
          for(let i=0;i< _this.subject.selest.length;i++){
            let temp= _this.subject.selest[i]
             temp['choice']=temp['choice'].split('----')
            _this.subject.selest[i]=temp
          }
        }else{
        }
      },
      //锚点跳转
      buttonitem(selector){
          var anchor = this.$el.querySelector(selector)
        document.documentElement.scrollTop =anchor.offsetTop
      },
    }

  }
</script>

<style scoped>
  /* 交卷 */
  >>>.sub {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }

  >>>.el-checkbox__label {
    display: inline;
  }

  >>>.el-checkbox, .el-checkbox__input {
    white-space: normal;
  }

  .main {
    min-height: calc(100vh - 40px);
    height: 100%;
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    position: relative;
    overflow: hidden;
    :#2add9c
  }

  @media print {
    .rightcon{
      display: none;
    }
    .main{
      width: 100%;
      padding: 0;
      margin: 0;
    }
    .top_title{
      display: block !important;
    }
    .leftcon{
      width: inherit !important;
    }
  }

  .top_title{
    display: none;
  }

  /* 左侧 */
  .leftcon {
    width: calc(70% - 20px);
    padding: 0;
    background-color: white;
    min-height: calc(100vh - 40px);
    z-index: 1000;
    margin-bottom: 20px;
  }

  .left-con {
    padding: 20px;
    padding-top: 0;
  }

  .title {
    background-color: #f6f8ff;
    line-height: 50px;
    height: 50px;
    font-size: 18px;
    font-weight: 600;
    padding: 0 20px;
    margin-top: 20px;
  }

  .con {
    padding: 20px;
    margin: 3px 0;
    border: 1px solid gainsboro;
  }

  .option {
    padding-left: 20px;
  }

  .optionitem {
    border-bottom: 1px solid gainsboro;
    padding: 5px;
    margin-top: 0;
  }
  .optionanswer{
    font-size: 15px;
    margin-top: 20px;
  }

  /* 交卷 */
  >>>.sub {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }

  /* 右侧 */
  .rightcon {
    width: 20%;
    background-color: white;
    position: fixed;
    top: 20px;
    right: 15%;
  }
  >>>.el-card__body {
    padding: 0;
    margin-bottom: 20px;
  }

  .right-con {
    padding: 20px;
  }

  .rightconhead {
    overflow: auto;
  }

  .detail {
    background-color: #f6f8ff;
    margin-bottom: 20px;
    padding: 20px;
  }

  .detailleft {
    width: 80px;
    margin-right: 10px;
    float: left;
    text-align-last:justify;
text-align:justify;
text-justify:distribute-all-lines;
  }

  time {
    background-color: #409EFF;
    width: 50%;
    float: right;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #f50000;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .rightconhead>div {
    float: left;
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: 600;
    background-color: #f6f8ff;
  }

  .num {
    padding: 0 10px;
    border: 2px solid #f6f8ff;
    border-top: none;
    width: calc( 100% - 24px );
    box-shadow: 5px 5px 5px #f6f8ff;
  }

  .num>.el-button {
    text-align: center;
    padding: 10px 5px;
    margin: 10px 5px;
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/evaluation/subject.vue